import { gql } from "@apollo/client";

const UserFragment = gql`
  fragment UserFields on User {
    id
    full_name
    first_name
    last_name
    preferred_full_name
    uses_team_admin_v2
    uses1099ContractorFeatures
  }
`;

export default UserFragment;
